export default __webpack_public_path__ + "static/media/info.edd0ff9b.svg";